﻿declare const UIkit: any;

interface notificationOptions
{
    title?: string;
    message?: string;
    status?: 'primary' | 'success' | 'warning' | 'danger';
    timeout?: number; // Visibility duration until a notification disappears. If set to 0, notification will not hide automatically.
    position?: string; // bv. 'top-right'
    group?: string;    // bv. 'shoppingcart'
}

export function showNotification({
    title = null,
    message = null,
    status = 'success',
    timeout = 5000,
    position = 'top-right',
    group = undefined,
}: notificationOptions)
{
    if (group)
    {
        // Find all active notification elements currently rendered in the DOM
        const activeElements = document.querySelectorAll('.uk-notification-message');

        activeElements.forEach((element) =>
        {
            element.remove();
        });
    }

    const iconClass = {
        success: 'ic-success',
        warning: 'ic-warning',
        danger: 'ic-danger',
        primary: 'ic-info',
    }[status];

    const hasProgress = timeout > 0;
    const titleTemplate = title ? `<span class="uk-notification-title">${title}</span>` : "";
    const messageTemplate = message ? `<span class="uk-notification-text">${message}</span>   ` : "";

    const notification = UIkit.notification({
        message: `
          <div class="uk-notification-holder uk-notification-${status}">
          <div class="uk-notification-inner">
            <span class="uk-notification-icon ${iconClass}"></span>
            ${titleTemplate}
            ${messageTemplate}
            </div>
            ${hasProgress ? '<div class="uk-notification-progress"></div>' : ''}
          </div>
    `,

        status,
        timeout: timeout,
        pos: position,
        group: group,
    });

    // close button
    const closeBtn = notification.$el.querySelector('.uk-notification-close');
    if (closeBtn)
    {
        closeBtn.addEventListener('click', () => notification.close());
    }

    // show progress bar only by timeout > 0
    if (hasProgress)
    {
        const progressEl = notification.$el.querySelector('.uk-notification-progress') as HTMLElement;
        if (progressEl)
        {
            progressEl.style.transition = `width ${timeout + 500}ms linear`;
            requestAnimationFrame(() =>
            {
                progressEl.style.width = '100%';
            });
        }
    }
}

(window as any).showNotification = showNotification;